enum VALUE_TYPES {
    POINTS = 'POINTS',
    COUPON_ID = 'COUPON_ID',
    COUPON_POS = 'COUPON_POS'
}
export default VALUE_TYPES;